import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AppLoadingService } from '@examdojo/app-state';
import { TopicPracticeDialogService } from './dialog/topic-practice-dialog.service';
import { TOPIC_PRACTICE_DIALOG_LOADER_ID } from './topic-practice-v2.model';

/**
 * A fake resolver that sets the loading state
 * before OpenPracticeDialogWhenActive is initialized.
 */
export const topicPracticeResolver: ResolveFn<void> = () => {
  const appLoadingService = inject(AppLoadingService);
  const dialogService = inject(TopicPracticeDialogService);

  // Only show loader when entering practice fresh (dialog not open).
  // If dialog is already open, we're switching modes - no loader needed.
  if (!dialogService.isOpen()) {
    appLoadingService.setLoading({ id: TOPIC_PRACTICE_DIALOG_LOADER_ID });
  }
};
